@if (isSectionVisible) {
<ppl-accordion [title]="pageTitle" [isOpen]="true">
  @if (isSectionEditable) {
  <div class="custom-row">
    <div class="mr-2">
      <ppl-button label="Create Purchase Request" icon="fa fa-plus" [customClass]="'primary-button'"
        [iconPosition]="'left'" (click)="openModal('add')"></ppl-button>
    </div>
  </div>
  }
  <p class="message">
    Please use the filters to view purchase requests.
  </p>
  <div class="purchase-request-filters">
    <form nz-form [formGroup]="purchaseRequestSearchForm">
      <nz-row [nzGutter]="16">
        <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please select a status'">
              <nz-select formControlName="status" class="ppl-select filters" id="status" nzPlaceHolder="Status"
                nzShowSearch nzAllowClear style="width: 100%;">
                @for(opt of purchaseRequestFilterStatus; track $index){
                <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueCode"></nz-option>
                }
              </nz-select>
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzSpan="4" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="5" [nzXXl]="5">
          <nz-form-item>
            <nz-form-control [nzErrorTip]="'Please enter the Vendor'">
              <input placeholder="Vendor" nz-input formControlName="vendor" id="vendor" />
            </nz-form-control>
          </nz-form-item>
        </nz-col>
        <nz-col nzSpan="" [nzXs]="8" [nzSm]="8" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3">
          <ppl-button label="Search" icon="fa fa-filter" [styleString]="'margin-top: -2px;'" [customClass]="'primary-button'"
            [iconPosition]="'left'" (click)="purchaseRequestFilterSearch()">
          </ppl-button>
        </nz-col>
      </nz-row>
    </form>
  </div>
  <ppl-accordion [title]="tableTitle" [isOpen]="true">
    @if(purchaseRequestData && purchaseRequestData.length > 0){
    <ppl-list-table #purchaseRequestsChildComponent rowDataAccessibilityKey="tasPurchaserequestDetailId"
      [customDataLoaded]="true" [loadPage]="true" [disableSort]="false" [disableSearch]="true" [showCustomSearch]="false"
      [enableActions]="true" [disableSelection]="true" [actionButtons]="actionButtonsInProcess"
      [data]="purchaseRequestData" [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="columnsToBeHidden"
      (gridAction)="onAction($event)" [pagination]="true" [from]="'claims'" [cols]="cols"
      (onPageLoad)="onPurchaseRequestPageLoad($event)">
    </ppl-list-table>
    }@else {
    <nz-row>
      <p>No Data found</p>
    </nz-row>
    }
  </ppl-accordion>
</ppl-accordion>
}

<div class="filter-panel">
  <ng-template #addPurchaseRequestDialog let-cancel="cancel">
    <ppl-create-purchase-request [consumerData]="consumerData" [mode]="'add'" [staffView]="false"
      (purchaseRequestEvent)="onPurchaseRequestCreated()" (cancel)="handleCancel($event)" [canApproveReject]="canApproveReject"></ppl-create-purchase-request>
  </ng-template>
</div>

<div class="filter-panel">
    <ng-template #viewPurchaseRequestDialog let-cancel="cancel">
        <ppl-create-purchase-request [mode]="mode" [purchaseRequestListData]="viewPurchaseRequestData" (purchaseRequestEvent)="onPurchaseRequestCreated()"
            (cancel)="handleCancel($event)" [staffView]="true" [canApproveReject]="canApproveReject"></ppl-create-purchase-request>
    </ng-template>
</div>
